import { render } from "./BarChart.vue?vue&type=template&id=3d4202af&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3d4202af"

export default script